export const environment = {
    production: true,
    stage: 'prod',
    backendUrl: process.env.REACT_APP_BACKEND_URL ?? 'https://backend.modernmedicus.pl/api',
};
